import React from 'react'
import { MDBContainer, MDBCol, MDBRow, MDBCard ,MDBView,MDBCardText,MDBCardTitle,MDBCardBody, MDBFooter, MDBIcon, MDBCardImage, MDBCardFooter} from 'mdbreact'

export default function chairman() {
    return (
        <div>
            <section className="p-5 teal">

            </section>
            <br    />
            <section>
                <br  />
                <MDBContainer className=""> 
             <MDBRow >
                  <MDBCol md="4" className="mb-3">
                    <MDBCard className="peach-gradient z-depth-2 hoverable">
                        
                        <div className="testmonial">
                            <MDBCardBody >
                                <div class="avatar mx-auto" >
                                    <center>
                                    <MDBView hover zoom>
                                    <img 
                                    src="http://visakhadairytrust.in/images/TulasiRao_web.jpg"
                                    className="rounded-circle z-depth-1 img-fluid m-3" 
                                    height="300px"
                                    width="200px"
                                    
                                    
                                    />
                                    </MDBView>
                                    </center>
                            
                                </div>
              
                                <MDBCardTitle className="">
                                    Adari Tulasi Rao
                                </MDBCardTitle>
                                <h6 class="font-weight-bold blue-text my-3">Chairman and founder</h6>
                                
                                
                            </MDBCardBody>
                                <MDBCardFooter className="p-2">
                                <MDBIcon fab icon="facebook"  className="mr-2" />
                                <MDBIcon fab icon="twitter"   className="mr-2" />
                                <MDBIcon fab icon="linkedin"  className="mr-2" />
                                </MDBCardFooter>
            
                        </div>
       
                     </MDBCard>
                 </MDBCol>
                 <MDBCol md="8" sm="12"  className="mb-3">

                     <MDBCard className="z-depth-2">
                         <MDBCardImage>

                         </MDBCardImage>
                         <MDBCardBody>
                             <MDBCardTitle>Chairman And Founder Message</MDBCardTitle>
                             <MDBCardText> <i class="fas fa-quote-left pr-2"></i>
We, the inspired Team of Employees are dedicated to Co-operation, Honesty, Discipline & Time, Quality & Purity, Hard Working, Transparency, Trust & Belief on Orianization, Mutual Respect, Skill Development & Education.
  </MDBCardText>
                         </MDBCardBody>
                         <MDBCardFooter>

                         </MDBCardFooter>

                     </MDBCard>
                  
                 </MDBCol>
            </MDBRow>
          </MDBContainer>
            </section>
        </div>
    )
}
